// MIT License - Copyright (c) 2026 Doug McNall
import { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { useAccessControl } from '../hooks/useAccessControl';
import { UserIcon, LogoutIcon, AlertTriangleIcon } from './Icons';
import ThemeSwitcher from './ThemeSwitcher';
import './AdminLayout.css';
import './Icons.css';

const AdminLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const { userProfile } = useAccessControl();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const userMenuRef = useRef(null);

  // Close user menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setShowUserMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = async () => {
    await logout();
    setShowUserMenu(false);
  };

  return (
    <div className="admin-layout">
      {/* Offline Mode Banner */}
      {userProfile?.offline_mode && (
        <div className="offline-banner">
          <AlertTriangleIcon size={16} />
          <span>Offline Mode: Backend API temporarily unavailable. Some features may be limited.</span>
        </div>
      )}
      
      <header className="admin-header">
        <div className="admin-header-content">
          <h1>D&D Hot Sauce Admin</h1>
          <nav className="admin-nav">
            <ThemeSwitcher />
            
            <div className="user-menu" ref={userMenuRef}>
              <button 
                className="user-menu-toggle"
                onClick={() => setShowUserMenu(!showUserMenu)}
              >
                <UserIcon size={18} />
                <span className="user-name">
                  {user?.attributes?.name || user?.attributes?.email || 'Admin'}
                </span>
                <span className="dropdown-arrow">▼</span>
              </button>
              
              {showUserMenu && (
                <div className="user-menu-dropdown">
                  <button onClick={handleLogout} className="logout-button">
                    <LogoutIcon size={16} />
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          </nav>
        </div>
      </header>
      <main className="admin-main">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;